<template>
  <div>
    <Warning v-if="propertyValueOverLimit"/>
    <FormHeading>Describe Property #{{ property }}</FormHeading>
    <FormInputLabel>Property Details</FormInputLabel>
    <TextInput
      v-model="description"
      name="description"
      label="Description"
      type="text"
      :error="errors['description']"
      @input="removeErrorMessage('description', $event)"
    />
    <FormGroup class="form-group-dates">
      <TextInput
        v-model="serialNumber"
        name="serialNumber"
        label="Serial Number"
        type="text"
        :error="errors['serialNumber']"
        @input="removeErrorMessage('serialNumber', $event)"
      />
      <TextInput
        v-model="year"
        name="year"
        label="Model Year"
        type="text"
        maxlength="4"
        :error="errors['year']"
        @input="removeErrorMessage('year', $event)"
      />
    </FormGroup>  

    <FormInputLabel class="radio-check-heading">Is there a lien on property #{{ property }}?</FormInputLabel>

    <FormGroup>
      <RadioButtons
        :value="lienHolder"
        name="lienHolder"
        label
        @change="handleChangeLienHolder"
        :items="lienHolderOption"
        :error="errors['lienholder_radio']"
        @resolve-error="errors['lienholder_radio'] = ''"
      />
    </FormGroup>
    <template v-if="lienHolder.value == 'lienHolder_yes'">
      <FormInputLabel>Property #{{ property }} Lienholder</FormInputLabel>

      <CheckboxButtons
        v-if="hasPreviousLien"
        :value="lienholder_same_as_first"
        :name="''"
        label
        @change="handleLienholderChange($event)"
        :items="sameAsOptionsForLien"
      />

      <TextInput v-model="lien.name" name="name" label="Name" type="text" :error="errors['lienholder_name']" @input="removeErrorMessage('lienholder_name', $event)"/>
      <div class="form-group fg-map" @keydown.enter.prevent>
        <SearchAddress :formName="'lien'" @get-address="getAddressLien" />
      </div>
      <FormGroup>
        <TextInput
          v-model="lien.street"
          name="streetNumber"
          label="Street Number & Name"
          type="text"
          :error="errors['lienholder_streetNumber']"
          @input="removeErrorMessage('lienholder_streetNumber', $event)"
        />
        <TextInput
          v-model="lien.unitNumber"
          name="unitNumber"
          label="Apt./Unit Number"
          type="text"
        />
      </FormGroup>
      <FormGroup>
        <TextInput v-model="lien.city" name="city" label="City" type="text" :error="errors['lienholder_city']" @input="removeErrorMessage('lienholder_city', $event)"/>
        <Suggest
          v-model="lien.state"
          name="lienState"
          label="State"
          :items="states"
          titleField="display"
          :hasFocus="true"
          @change="handleLienStateChange"
          :error="errors['lienholder_state']"
        />
        <TextInput v-model="lien.zip" name="zipCode" label="Zip Code" type="number" :error="errors['lienholder_zipCode']" @input="removeErrorMessage('lienholder_zipCode', $event)"/>
      </FormGroup>
    </template>
    <div class="button-group">
      <Button class="transparent" @click="prev">Back</Button>
      <Button class="red" @click="checkForm">Continue</Button>
    </div>
  </div>
</template>

<script>
import {
  FormHeading,
  FormInputLabel,
  Button,
  TextInput,
  FormGroup,
  RadioButtons,
  Suggest,
  CheckboxButtons,
} from "../../style";
import Warning from "../Warning";
import { STATES, PROPERTY_LOCATIONS } from "../../utils/constants";
import SearchAddress from "./SearchAddress";
import { scrollTop } from "../../utils";
export default {
  name: "PropertyDescription",
  props: {
    step: {
      type: Number,
      required: true
    },
    properties: {
      type: Array,
      default: () => []
    },
    property: {
      type: Number,
      default: 1
    }
  },
  components: {
    Warning,
    FormHeading,
    FormInputLabel,
    Button,
    TextInput,
    FormGroup,
    RadioButtons,
    Suggest,
    SearchAddress,
    CheckboxButtons,
  },
  mounted() {
    scrollTop();
  },
  data() {
    return {
      description: "",
      serialNumber: "",
      streetNumber: "",
      year: "",
      unitNumber: "",
      zipCode: "",
      city: "",
      state: null,
      lien: {
        name: "",
        street: "",
        streetNumber: "",
        address1: "",
        address2: "",
        unitNumber: "",
        zip: "",
        city: "",
        state: null,
        county: "",
        lat: "",
        lng: ""
      },
      lienHolder: {},
      errors: {
        description: "",
        serialNumber: "",
        streetNumber: "",
        unitNumber: "",
        city: "",
        zipCode: "",
        state: "",
        lienholder_radio: "",
        lienholder_name: "",
        lienholder_streetNumber: "",
        lienholder_city: "",
        lienholder_zipCode: "",
        lienholder_state: "",
        year: ""
      },
      location_same_as_first: [],
      lienholder_same_as_first: [],
      validStateError: 0,
      errorFields: []
    };
  },
  methods: {
    checkForm() {
      let preventSubmit = false;
      this.errorFields = [];
      if (this.description.trim().length === 0) {
        this.errors["description"] = "Property description is required.";
        this.errorFields.push("description");
        preventSubmit = true;
      }
      if (this.serialNumber.trim().length === 0) {
        this.errors["serialNumber"] = "Serial number is required.";
        this.errorFields.push("serialNumber");
        preventSubmit = true;
      }
      if (this.year.trim().length) {
        if ( !/^\d+$/.test(this.year.trim()) ) {
          this.errors["year"] = "Enter a valid year.";
          this.errorFields.push("year");
          preventSubmit = true;
        }
      }
      if (Object.keys(this.lienHolder).length === 0) {
        this.errors["lienholder_radio"] = "Please select if there is a lien.";
        this.errorFields.push("lienHolder_yes");
        preventSubmit = true;
      }
      if (this.lienHolder.row_val === 1) {
        if (this.lien.name.trim().length === 0) {
          this.errors["lienholder_name"] = "Name is required.";
          this.errorFields.push("name");
          preventSubmit = true;
        }
        if (this.lien.street.trim().length === 0) {
          this.errors["lienholder_streetNumber"] = "Street address is required.";
          this.errorFields.push("streetNumber");
          preventSubmit = true;
        }
        if (this.lien.city.trim().length === 0) {
          this.errors["lienholder_city"] = "City is required.";
          this.errorFields.push("city");
          preventSubmit = true;
        }
        if (this.lien.state === null || this.lien.state === undefined) {
          this.errors["lienholder_state"] = "State is required.";
          this.errorFields.push("lienState");
          preventSubmit = true;
        }
        if (this.lien.zip.trim().length === 0) {
          this.errors["lienholder_zipCode"] = "Zip code is required.";
          this.errorFields.push("zipCode");
          preventSubmit = true;
        }
      }
      if(this.errorFields.length > 0)
        document.getElementById(this.errorFields[0]).scrollIntoView({behavior: "smooth", block: "center"});
      if (!preventSubmit) {
        this.next();
      }
    },
    next() {
      const propertyDescription = {
        description: this.description,
        serial: this.serialNumber,
      };
      if (this.lienHolder.row_val === 1) {
        propertyDescription["lien"] = this.lien;
        if (this.lien.state) {
          propertyDescription["lien"]["state"] = this.lien.state.value;
        }
      }
      if (this.year && this.year.trim().length) {
        propertyDescription["year"] = this.year;
      }
      this.$emit("format-property", propertyDescription);
      this.$emit("next-step");
    },
    prev() {
      this.$emit("prev-step");
    },
    getAddressLien($event) {
      const { addressData, placeResultData } = $event;
      this.lien.lat = addressData.latitude.toString();
      this.lien.lng = addressData.longitude.toString();
      let types = [];

      for (let i = 0; i < placeResultData.address_components.length; i++) {
        let type = placeResultData.address_components[i].types[0];
        let componentForm = {
          street_number: "short_name",
          route: "long_name",
          locality: "long_name",
          administrative_area_level_1: "short_name",
          administrative_area_level_2: "short_name",
          country: "long_name",
          postal_code: "short_name"
        };
        types.push(type);

        switch (type) {
        case "street_number":
          this.lien.street =
            placeResultData.address_components[i][componentForm[type]];
          this.lien.streetNumber = placeResultData.address_components[i][componentForm[type]];
          this.removeErrorMessage("lienholder_streetNumber", this.lien.street);
          break;

        case "route":
          this.lien.street = this.lien.street + " " +
            placeResultData.address_components[i][componentForm[type]];
          this.lien.address1 = placeResultData.address_components[i][componentForm[type]];
          this.removeErrorMessage("lienholder_streetNumber", this.lien.street);
          break;
        
        case "address2":
          this.lien.address2 =  placeResultData.address_components[i][componentForm[type]];
          break;

        case "locality":
          this.lien.city =
            placeResultData.address_components[i][componentForm[type]];
          this.removeErrorMessage("lienholder_city", this.lien.city);
          break;

        case "administrative_area_level_1":
          this.lien.state = {
            value: placeResultData.address_components[i][componentForm[type]],
            display:
              STATES[
                placeResultData.address_components[i][componentForm[type]]
              ]
          };
          this.removeErrorMessage("lienholder_state", this.lien.state);
          break;

        case "postal_code":
          this.lien.zip =
            placeResultData.address_components[i][componentForm[type]];
          this.removeErrorMessage("lienholder_zipCode", this.lien.zip);
          break;
        case "administrative_area_level_2":
          this.lien.county = placeResultData.address_components[i][componentForm[type]];
          break;
        }
      }
      if (types.indexOf("postal_code") < 0) {
        this.lien.zip = "";
      }
    },
    handleLienStateChange($event) {
      if ($event) {
        this.errors["lienholder_state"] = "";
      }

      this.lien.state = $event;
    },
    removeErrorMessage(field) {
      this.errors[field] = "";
    },
    handleLocationPropertyChange($event) {
      if (this.location_same_as_first.length) {
        this.location_same_as_first.pop($event.value);
      } else {
        this.location_same_as_first.push($event.value);
      }
      this.handleSameLocation();
    },
    handleSameLocation() {
      if (this.location_same_as_first.length) {
        const { street, unitNumber, city, state, zip } = this.properties[0];
        this.$emit("set-same-as-property");
        this.validStateError = 0;
        this.streetNumber = street;
        this.removeErrorMessage("streetNumber", this.streetNumber);
        this.unitNumber = unitNumber;
        this.removeErrorMessage("unitNumber", this.unitNumber);
        this.city = city;
        this.removeErrorMessage("city", this.city);
        if (state) {
          this.state = {
            value: state,
            display: STATES[state]
          };
        }
        this.removeErrorMessage("state", this.state);
        this.zipCode = zip;
        this.removeErrorMessage("zipCode", this.zipCode);
      } else {
        this.streetNumber = "";
        this.unitNumber = "";
        this.city = "";
        this.state = null;
        this.zipCode = "";
        delete this.properties[this.property - 1]["sameAsPropertyOne"];
      }
    },
    handleLienholderChange($event){
      if (this.lienholder_same_as_first.length) {
        this.lienholder_same_as_first.pop($event.value);
      } else {
        this.lienholder_same_as_first.push($event.value);
      }

      this.handleSameLienholder();
    },
    handleSameLienholder() {
      if (this.lienholder_same_as_first.length) {
        const { name, street, unitNumber, city, state, zip } = this.properties[0].lien;
        
        this.lien.name = name;
        this.removeErrorMessage("lienholder_name", this.lien.name);
        this.lien.street = street;
        this.lien.unitNumber = unitNumber;
        this.lien.city = city;
        this.removeErrorMessage("lienholder_city", this.lien.city);
        if (state) {
          this.lien.state = {
            value: state,
            display: STATES[state]
          };
        }
        this.removeErrorMessage("lienholder_state", this.lien.state);
        this.lien.zip = zip;
        this.removeErrorMessage("lienholder_zipCode", this.lien.zip);
      } else {
        this.lien.name = "";
        this.lien.street = "";
        this.lien.unitNumber = "";
        this.lien.city = "";
        this.lien.state = null;
        this.lien.zip = "";
      }
    },
    handleChangeLienHolder($event) {
      if ($event.row_val == 0) {
        delete this.properties[this.property - 1]["lien"];
      }
      return this.lienHolder = $event;
    },
    returnStepOne() {
      const propertyDescription = {
        description: this.description,
        serial: this.serialNumber,
        street: this.streetNumber,
        unitNumber: this.unitNumber,
        zip: this.zipCode,
        city: this.city,
        state: this.state ? this.state.value : null
      };
      if (this.lienHolder.row_val === 1) {
        propertyDescription["lien"] = this.lien;
        if (this.lien.state) {
          propertyDescription["lien"]["state"] = this.lien.state.value;
        }
      }
      if (this.year && this.year.trim().length) {
        propertyDescription["year"] = this.year;
      }
      this.$emit("step-one"); 
      this.$emit("format-property", propertyDescription);
    },
    getStateName(abbrev) {
      return STATES[abbrev];
    },
  },
  computed: {
    lienHolderOption() {
      return [
        {
          value: "lienHolder_yes",
          row_val: 1,
          display: "Yes"
        },
        {
          value: "lienHolder_no",
          row_val: 0,
          display: "No"
        }
      ];
    },
    states() {
      let states = Object.keys(STATES).map(s => {
        return {
          value: s,
          display: STATES[s]
        };
      });
      return states;
    },
    sameAsOptions() {
      return [
        {
          value: "location_same_as_first",
          row_val: "location_same_as_first",
          display: "Same as Property #1's location"
        }
      ];
    },
    sameAsOptionsForLien() {
      return [
        {
          value: "lienholder_same_as_first",
          row_val: "lienholder_same_as_first",
          display: "Same as Property #1's lienholder"
        }
      ];
    },
    hasPreviousLien() {
      return this.property > 1 && Object.prototype.hasOwnProperty.call(this.properties[0], "lien");
    },
    hasPreviousProperty() {
      return this.property > 1 && this.properties[this.property - 1];
    },
    validStates() {
      return PROPERTY_LOCATIONS.map(location => {
        return location.abbrev;
      });
    },
    propertyValueOverLimit() {
      let value = 0;
      if (this.properties.length) {
        this.properties.forEach(property => {
          value += parseFloat(property.value);
        });
      }
      return value > 100000;
    },
  },
  watch: {
    properties: {
      immediate: true,
      handler(newVal) {
        if (newVal[this.property - 1]) {
          const { description, serial, year, street, unitNumber, zip, city, state, sameAsPropertyOne, lien } = newVal[this.property - 1];
          if (description) {
            this.description = description;
          }
          if (serial) {
            this.serialNumber = serial;
          }
          if (year) {
            this.year = year;
          }
          if (street) {
            this.streetNumber = street;
          }
          if (unitNumber) {
            this.unitNumber = unitNumber;
          }
          if (zip) {
            this.zipCode = zip;
          }
          if (city) {
            this.city = city;
          }
          if (state) {
            this.state = {
              value: state,
              display: STATES[state]
            };
          }
          if (sameAsPropertyOne) {
            this.location_same_as_first.push(this.sameAsOptions[0].value);
          }

          if (description) {
            this.lienHolder = lien ? this.lienHolderOption[0] : this.lienHolderOption[1];
            
            if (lien) {
              this.lien.name = lien.name;
              this.lien.street = lien.street;
              this.lien.unitNumber = lien.unitNumber;
              this.lien.city = lien.city;
              this.lien.state = {
                value: lien.state,
                display: STATES[lien.state]
              }
              this.lien.zip = lien.zip;
            }
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.button-group {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  button:last-of-type {
    margin-left: $padding-lg;
  }
}
.error-state {
  padding-left: 0;
  line-height: 1.5rem;
  .error-link {
    color: $blue-navy;
    cursor: pointer;
    font-weight: 700;
  }
  .strong {
    font-weight: 700;
    font-style: normal; 
  }
}
</style>
